export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const DELETE_ROLE = "DELETE_ROLE";
export const UPDATE_ROLE_NAME = "UPDATE_ROLE_NAME";
export const ADD_ROLE_NAME = "ADD_ROLE_NAME";
export const GET_ROLE_USERS = "GET_ROLE_USERS";
export const DELETE_ROLE_USERS = "DELETE_ROLE_USERS";
export const GET_ROLE_PERMISSIONS = "GET_ROLE_PERMISSIONS";
export const UPDATE_ROLE_PERMISSIONS = "UPDATE_ROLE_PERMISSIONS";
